<div nz-row nzType="flex" nzJustify="center" nzAlign="top">
  <nz-content>
      <form nz-form [nzLayout]="'vertical'" #tariffForm='ngForm'>

<div nz-row [nzGutter]="16" class="align-end">
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="10" nzXl="10">
        <span class="text-wrap">Code</span>
        <i nz-icon nzType="question-circle" nz-tooltip nzTheme="outline"
            nzTooltipTitle="Search by Code"></i>
        <input nz-input [(ngModel)]="viewModel.tariffCode" [ngModelOptions]="{standalone: true}">
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="10" nzXl="10">
        <span class="text-wrap">Description</span>
        <i nz-icon nzType="question-circle" nz-tooltip nzTheme="outline"
            nzTooltipTitle="Search by Description"></i>
        <input nz-input [(ngModel)]="viewModel.shortDescriptionInEnglish" [ngModelOptions]="{standalone: true}">
    </div>
   <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="4" nzXl="4" class="pl10">
        <button nz-button nzType="default" [nzLoading]="isSpinningFind"
            (click)="findHsCode(1);">
            <span> <i nz-icon nzType="search" nzTheme="outline"></i> Search </span>
        </button>
    </div>
</div>
<br>


          <nz-divider class="mt-sm mb0"></nz-divider>
          <nz-table #basicTable nzBordered nzShowSizeChanger [nzData]="viewModel.hsCodeList" [nzTemplateMode]="viewModel.hsCodeList.length > 0" [nzTotal]="totalElements" [nzFrontPagination]="false" [nzShowPagination]="true" [nzHideOnSinglePage]="true" [nzPageSize]='pageSize' [nzPageSizeOptions]="pageSizeOptions"
            [(nzPageIndex)]="pageIndex"
            (nzPageSizeChange)="changePageSize($event)"
            [nzLoading]="isSpinningFind"
            class="mt-lg clear-both"
            *ngIf="!viewModel.mode3CE && isViewEnabled">

            <thead>
              <tr>
                <th nzWidth="62px">
                  <label *ngIf="!singleSelect" nz-checkbox [(ngModel)]="isAllSelected" [ngModelOptions]="{standalone: true}" [nzIndeterminate]="indeterminate" (ngModelChange)="onAllChecked($event)"></label>
                </th>
                <th>Code</th>
                <th>Description</th>
                <th nzWidth="15%">Unit of Measure</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of basicTable.data; let i=index">
                <td>
                  <label *ngIf="!singleSelect" nz-checkbox [nzChecked]="isSelected(data)" (nzCheckedChange)="onItemChecked(data, $event)"></label>
                  <label *ngIf="singleSelect" nz-radio [ngModelOptions]="{standalone: true}" [ngModel]="isSelected(data)" (ngModelChange)="onItemChecked(data, $event)"></label>
                </td>
                <td>{{ data?.tariffCode }}</td>
                <td>{{ data?.descriptionInEnglish}}</td>
                <td>{{ data?.uom }}</td>
              </tr>
            </tbody>
          </nz-table>

          <div class="spacer"></div> <!-- Spacer for pagination -->
          <div class="drawer-footer">
            <button nz-button nzType="default" (click)="cancel()">
                <i nz-icon nzType="stop" nzTheme="outline"></i>
                Cancel
            </button>
            <button nz-button nzType="primary" [disabled]="selectedTariffs.length === 0" (click)="submit()">
                <i nz-icon nzType="check" nzTheme="outline"></i>
                Submit
            </button>
          </div>

          <div nz-row *ngIf="viewModel.mode3CE && isViewEnabled">
            <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
            <app-form-iframe [iFrameLink]="viewModel.url3CE"></app-form-iframe>
          </div>
          </div>
      </form>
  </nz-content>
</div>
